export default {
  title: 'Campagnes',
  actions: {
    create: 'créer une campagne'
  },
  empty: {
    title: 'Aucune campagne',
    message: 'Pour créer une campagne, rien de plus simple, il suffit de cliquer sur le lien suivant :'
  },
  state: {
    published: 'publié',
    testing: 'en test',
    terminated: 'terminé'
  },
  modal: {
    create: {
      title: 'Créer une campagne',
      fields: {
        name: 'Nom',
        period: 'Restreindre la période',
        date: {
          start: 'Début',
          end: 'Fin'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/translations/fr/campaign.js